<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { Toaster } from '@/components/ui/sonner'

// Bootstrap: try to resolve the current session on app start. If the
// cookie is still valid this populates the auth store and the router
// guard happily lets the user land on their last URL. If not, the
// guard redirects to /login.
const auth = useAuthStore()
onMounted(() => {
  void auth.bootstrap()
})
</script>

<template>
  <RouterView />
  <!-- ADR-012: global toast surface. Mounted at root so any page can
       call toast.success() / toast.error() via vue-sonner without
       wiring a portal each time. Bottom-right keeps it out of the
       way of the AppShell sidebar. -->
  <Toaster position="bottom-right" rich-colors />
</template>
